module.exports = __webpack_public_path__ + "assets/img/ProspectusBAIOS.5568b0d7.png";